const COLOR_DISPLAY = {
  "Charcoal": "Stonewashed Charcoal",
  "Olive": "Stonewashed Olive",
  "Sand": "Stonewashed Sand",
  "Black": "Stonewashed Black",
};

export function formatPrice(price) {
  const num = typeof price === "number" ? price : parseFloat(price);
  if (isNaN(num)) return "AUD $0";
  return num % 1 === 0 ? `AUD $${Math.round(num)}` : `AUD $${num.toFixed(2)}`;
}

export function displayColor(color) {
  return COLOR_DISPLAY[color] || `Stonewashed ${color}`;
}
